module.exports = __webpack_public_path__ + "static/media/SING-Curtin.2520bf15.png";